const targetClass = 'kl-teaser-Ymbyjc';

const observer = new MutationObserver(function (mutationsList, observer) {
  const teaserDiv = document.querySelector(`div.${targetClass}`);
  if (teaserDiv) {
    teaserDiv.setAttribute('role', 'presentation');
    observer.disconnect(); // Stop observing once we've found and modified the element
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
